import { createJSONStorage } from "zustand/middleware";

/**
 * Initial state for the user preferences store
 */
export const initialState = {
  preferences: {}, // { key: value } map of all loaded preferences
  loading: {}, // { key: boolean } map of loading states
  errors: {}, // { key: error } map of errors
  initialized: false,
};

/**
 * Persist configuration for the user preferences store
 */
export const persistConfig = {
  name: "user-preferences-storage",
  storage: createJSONStorage(() => sessionStorage),
  partialize: (state) => ({
    preferences: state.preferences,
    initialized: state.initialized,
  }),
};
